import ecoRebatesActionTypes from 'yoda-site-components/lib/actionTypes/EcoRebatesActionTypes';

function BundleEcoRebatesReducer(state = {}, action) {
    switch (action.type) {
        case ecoRebatesActionTypes.BUNDLE_ECOREBATES_GET_SUCCESS:
            return {
                ...state,
                [action.payload.ppId]: action.payload,
            };
        default:
            return state;
    }
}

BundleEcoRebatesReducer.reducerName = 'bundleEcoRebates';
export default BundleEcoRebatesReducer;
